export default "__VITE_ASSET__fuzuyuLW__"